// Monday-Sunday week grouping (America/New_York) — extracted out of
// BacklogQueue.js (its "Shipped This Week"/Release Notes grouping) once a
// second page (Week at a Glance) needed the same "what week does this date
// fall in" logic. BacklogQueue.js imports these instead of keeping its own
// copy.

export const toNY = (d) => new Date(d.toLocaleString('en-US', { timeZone: 'America/New_York' }));

export const getWeekStart = (d) => {
  const ny = toNY(d);
  const day = ny.getDay(); // 0 Sun .. 6 Sat
  const monday = new Date(ny.getFullYear(), ny.getMonth(), ny.getDate() - (day === 0 ? 6 : day - 1));
  monday.setHours(0, 0, 0, 0);
  return monday;
};

export const isInWeek = (iso, weekStart) => {
  if (!iso) return false;
  const d = toNY(new Date(iso.endsWith('Z') || iso.includes('+') ? iso : iso + 'Z'));
  const weekEnd = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 7);
  return d >= weekStart && d < weekEnd;
};

export const weekLabel = (weekStart) => {
  const weekEnd = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 6);
  const opt = { month: 'short', day: 'numeric' };
  return `Week of ${weekStart.toLocaleDateString('en-US', opt)} – ${weekEnd.toLocaleDateString('en-US', { ...opt, year: 'numeric' })}`;
};

// Mon-Fri variant for Week at a Glance's nav label ("Week of Aug 17–21") —
// deliberately shorter than weekLabel() above (no year, Friday not Sunday)
// since that page only ever schedules against workdays.
export const workweekLabel = (weekStart) => {
  const friday = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 4);
  const opt = { month: 'short', day: 'numeric' };
  return `Week of ${weekStart.toLocaleDateString('en-US', opt)}–${friday.toLocaleDateString('en-US', { day: 'numeric' })}`;
};

export const addWeeks = (weekStart, n) =>
  new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + n * 7);

// Local-calendar-day YYYY-MM-DD — never use d.toISOString() for this, it
// shifts to UTC first and can roll the date to the wrong day near midnight.
export const toISODateString = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
